import { render, staticRenderFns } from "./waterPurifierMng.vue?vue&type=template&id=0086a7f1&scoped=true"
import script from "./waterPurifierMng.vue?vue&type=script&lang=js"
export * from "./waterPurifierMng.vue?vue&type=script&lang=js"
import style0 from "./waterPurifierMng.vue?vue&type=style&index=0&id=0086a7f1&prod&lang=css"
import style1 from "./waterPurifierMng.vue?vue&type=style&index=1&id=0086a7f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0086a7f1",
  null
  
)

export default component.exports